import React from 'react';
import { ratingTypes } from '../../../utils/constants';
import styles from '../search.scss';

const JuniorCircuitsHeaderColumns = props => {
    const { juniorCircuits } = props;

    return (
        juniorCircuits.total > 0
            ? (
                <div>
                    <div className={`${styles.searchHeaders} d-none d-md-flex`} data-testid="search.junior-circuits.column-headers">
                        <div className="flex-grow">
                            <div className={`searchHeaderRow row`}>
                                <div className="d-grid w-100" style={{ gridTemplateColumns: '0.2fr 3fr 1fr 1fr 1fr 1fr 1.5fr 1.5fr 1.5fr', columnGap: '10px' }}>
                                    <div />
                                    <div className={`${styles.searchHeaderColumn}`} data-testid="search.junior-circuits.column-header.name">
                                        NAME
                                    </div>
                                    <div className={`${styles.searchHeaderColumn}`} data-testid="search.junior-circuits.column-header.region">
                                        REGION
                                    </div>
                                    <div className={`${styles.searchHeaderColumn}`} data-testid="search.junior-circuits.column-header.fees">
                                        FEES
                                    </div>
                                    <div className={`${styles.searchHeaderColumn}`} data-testid="search.junior-circuits.column-header.utr-rating">
                                        {ratingTypes.tennis}
                                    </div>
                                    <div className={`${styles.searchHeaderColumn}`} data-testid="search.junior-circuits.column-header.gender">
                                        GENDER
                                    </div>
                                    <div className={`${styles.searchHeaderColumn}`} data-testid="search.junior-circuits.column-header.type">
                                        TYPE
                                    </div>
                                    <div className={`${styles.searchHeaderColumn}`} data-testid="search.junior-circuits.column-header.date">
                                        DATE
                                    </div>
                                    <div className={`${styles.searchHeaderColumn}`} data-testid="search.junior-circuits.column-header.status">
                                        STATUS
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className={`${styles.searchHeaders} d-block d-md-none`}>
                        {filterType ? (
                            <div className={``}>
                        Sort by
                                <select
                                    className="inline-input"
                                    value={sortValue}
                                    onChange={(e) => sort(e.target.value)}
                                >
                                    <option value="">Relevance</option>
                                    {sortOptions.map((option, i) => <option value={option.value} key={`playerSort${i}`}>{option.label}</option>)}
                                </select>
                            </div>
                        ) : 'Players'}
                    </div> */}
                </div>
            ) : <div />
    );
};

export default JuniorCircuitsHeaderColumns;
